import {SqlColumnType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {
  AvailableColumn,
  AvailableColumnType,
  ColumnFilterType,
  FormType,
  NonInitializedSQLTemplateFormState,
  TextAvailableColumnTypeInfo,
} from './SQLTemplateFormTypes';

export const POTENTIAL_LINK_COLUMN_TYPES = [
  SqlColumnType.CHARACTER_VARYING,
  SqlColumnType.JSON,
  SqlColumnType.JSONB,
];
export const TEXT_COLUMN_TYPE_INFO: TextAvailableColumnTypeInfo = {type: AvailableColumnType.TEXT};
export const DEFAULT_AVAILABLE_COLUMN_STATE: Omit<AvailableColumn, 'columnData' | 'alias'> = {
  selected: false,
  typeInfo: TEXT_COLUMN_TYPE_INFO,
  validationError: null,
};
export const DEFAULT_COLUMN_FILTER_PROPERTIES = {
  filterType: ColumnFilterType.IS_ONE_OF,
  rawValues: '',
  validationError: null,
  values: [],
};

export const DEFAULT_SQL_TEMPLATE_FORM_STATE: NonInitializedSQLTemplateFormState = {
  selectedTable: null,
  excludeDuplicates: false,
  formType: FormType.BASIC_BIOENTITY,
};

export const FILTER_OPERATOR_TYPE_TO_READABLE: {[key in ColumnFilterType]: string} = {
  [ColumnFilterType.EQUALS]: 'equals',
  [ColumnFilterType.GTE]: 'is at least',
  [ColumnFilterType.IS_ONE_OF]: 'is one of',
  [ColumnFilterType.IS_NONE_OF]: 'is none of',
  [ColumnFilterType.IS_NOT_NULL]: 'is not null',
  [ColumnFilterType.IS_NULL]: 'is null',
  [ColumnFilterType.LTE]: 'is at most',
  [ColumnFilterType.NOT_EQUALS]: 'not equals',
};

export const FILTERED_COLUMN_TYPE_IS_SUPPORTED: {[key in SqlColumnType]: boolean} = {
  [SqlColumnType.BOOLEAN]: false,
  [SqlColumnType.CHARACTER_VARYING]: true,
  [SqlColumnType.DATE]: false,
  [SqlColumnType.DOUBLE]: false,
  [SqlColumnType.INTEGER]: false,
  [SqlColumnType.JSON]: true,
  [SqlColumnType.JSONB]: true,
  [SqlColumnType.NUMERIC]: false,
  [SqlColumnType.TIMESTAMP]: false,
  [SqlColumnType.UNKNOWN]: false,
  [SqlColumnType.UUID]: false,
};

export const FORBIDDEN_COLUMN_ALIAS_STRINGS = ['"'];
export const FORBIDDEN_FILTER_VALUE_STRINGS = ["'", '{{', '}}'];
